import React, { useRef } from 'react'
import { FileCard as DsFileCard } from '@enamelai/design-system'
import {
  buildFileActions,
  getFileTypeFromFileName,
  withMaskMenuIcons,
  type FileMenuHandlers,
} from '@components/pages/Files/filesAndLetters.util'
import './FileCard.css'

export type FileCardProps = {
  fileName: string
  fileSize: string
  uploadDate: string
  isSelected: boolean
  isFavorite: boolean
  onSelect: () => void
  onFavorite: () => void
  onRenameConfirm?: (newName: string) => void
  isRenaming?: boolean
} & FileMenuHandlers

/**
 * DS FileCard routes both card clicks and the checkbox to `onSelect`; the Files
 * module opens the file on card click and only selects via the checkbox.
 */
const FileCard: React.FC<FileCardProps> = ({
  fileName,
  fileSize,
  uploadDate,
  isSelected,
  isFavorite,
  onSelect,
  onFavorite,
  onRenameConfirm,
  isRenaming = false,
  ...menuHandlers
}) => {
  const kind = getFileTypeFromFileName(fileName)
  const fromCheckboxRef = useRef(false)

  const openFile = (): void => {
    if (kind === 'dcm' && menuHandlers.onViewWithDicom) {
      menuHandlers.onViewWithDicom()
      return
    }
    menuHandlers.onView?.()
  }

  return (
    <div
      className="fal-file-card"
      onClickCapture={(e) => {
        fromCheckboxRef.current = Boolean(
          (e.target as HTMLElement).closest('.ds-file-card__select'),
        )
      }}
      onKeyDownCapture={() => {
        fromCheckboxRef.current = false
      }}
    >
      <DsFileCard
        fileName={fileName}
        fileSize={fileSize}
        uploadDate={uploadDate}
        fileType={kind}
        selected={isSelected}
        favorite={isFavorite}
        renaming={isRenaming}
        actions={withMaskMenuIcons(buildFileActions(menuHandlers))}
        onSelect={() => {
          if (fromCheckboxRef.current) {
            fromCheckboxRef.current = false
            onSelect()
            return
          }
          openFile()
        }}
        onFavorite={onFavorite}
        onRenameConfirm={onRenameConfirm}
      />
    </div>
  )
}

export default FileCard
